(function () {
  'use strict';

  angular.module('app').component('providerTypeDetail', providerTypeDetail());

  function providerTypeDetail() {
    return {
      bindings: {
        item: '=',
        mode: '=',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: ProviderTypeDetailCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/provider-types/provider-type-detail/provider-type-detail.component.html',
    };
  }

  ProviderTypeDetailCtrl.$inject = ['UtilService', 'ProviderTypeService'];

  function ProviderTypeDetailCtrl(UtilService, ProviderTypeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = ['name', 'description', 'is_business', 'commissionable'];

    // Methods
    //vm.openTranslations = openTranslations;
    vm.editProviderType = editProviderType;
    vm.cancelEdit = cancelEdit;
    vm.saveProviderType = saveProviderType;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          is_business: false,
          commissionable: false,
        };
      }
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editProviderType();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editProviderType() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    // Create/Update
    function saveProviderType(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        ProviderTypeService.saveProviderType(vm.item, vm.defaultLanguage).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            setItemOptions(response);
            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem();
    }
  }
})();
